import { Button } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';
import { useTheme } from '@mui/material/styles';

interface CancelButtonProps {
  cancelHandler: () => void;
  label: string;
  className?: string;
}

const CancelButton = (props: CancelButtonProps) => {
  const { cancelHandler, label, className } = props;
  const theme = useTheme();

  return (
    <Button
      style={{ color: `${theme.color.state.stateError}` }}
      color="primary"
      variant="text"
      onClick={cancelHandler}
      size="small"
      className={className}
    >
      <IconWithLabel
        iconSize="M"
        iconName={IconName.cross}
        iconColor={theme.color.state.stateError}
        label={label}
        typographyProps={{
          variant: 'h5',
        }}
      />
    </Button>
  );
};

export default CancelButton;
